/*
 * Galeria do produto: destaque da miniatura ativa.
 *
 * O carrossel em si é do navegador (scroll-snap) e as miniaturas são âncoras
 * comuns — tudo funciona sem este arquivo. Aqui só marcamos qual foto está em
 * cena e impedimos que a âncora sacuda a página inteira ao rolar a fila.
 */
(function () {
  'use strict';

  var galeria = document.querySelector('[data-yasy-galeria]');
  if (!galeria) return;

  var fila = galeria.querySelector('ul');
  var thumbs = galeria.querySelectorAll('[data-galeria-thumb]');
  if (!fila || !thumbs.length) return;

  function marcar(indice) {
    Array.prototype.forEach.call(thumbs, function (t) {
      var ativa = t.getAttribute('data-galeria-thumb') === String(indice);
      t.setAttribute('aria-current', ativa ? 'true' : 'false');
    });
  }

  marcar(1);

  /* `scrollIntoView` com block:'nearest' move só a fila. Um href="#foto-2"
     puro moveria a página junto até o elemento. */
  Array.prototype.forEach.call(thumbs, function (t) {
    t.addEventListener('click', function (e) {
      var alvo = document.getElementById('yasy-foto-' + t.getAttribute('data-galeria-thumb'));
      if (!alvo) return;
      e.preventDefault();
      alvo.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    });
  });

  if (typeof IntersectionObserver === 'undefined') return;

  var observador = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (entrada) {
      if (!entrada.isIntersecting) return;
      var id = entrada.target.id.replace('yasy-foto-', '');
      marcar(id);
    });
  }, { root: fila, threshold: 0.6 });

  Array.prototype.forEach.call(fila.children, function (li) { observador.observe(li); });
})();
